import { HttpClient } from '../../../commonApis/httpClient'
import * as ApiEvents from './apiEvents'
const deleteEvent = (eventMessage) => {
  const data = {
    eventMessage: eventMessage,
    eventType: ApiEvents.DELETE_NL_ENTITY,
    eventTime: Date.now(),
  }
  return data
}

export const deleteMultipleTabs = (invoiceId, merchandiseId, intentExportValue, key, id) => {
  let currentId = key === 'containers' ? 'containerId' : 'id'
  let dataSent = deleteEvent({
    shipmentId: { id: window.shipmentId },
    intentExport: { value: intentExportValue == 'EX' ? true : false },

    invoices: [
      {
        shipmentId: window.shipmentId,
        invoiceId: invoiceId,
        lineItems: [
          {
            merchandiseId: merchandiseId,
            invoiceId: invoiceId,
            [key]: [
              {
                [`${currentId}`]: id,
                type: 'SELLER',
              },
            ],
          },
        ],
      },
    ],
  })

  return HttpClient.post(dataSent)
    .then((resp) => resp)
    .catch((error) => {
      showToast('Something went wrong,cannot save the value!')
      console.error(`Error in delete deleteMerchandiseInfo : `, error)
    })
}
